import { useBlockExplorerBaseUrl } from './useBlockExplorerBaseUrl'

const trim = (u?: string) => u?.replace(/\/+$/, '')

export default function useExplorerLinks() {
  const base = trim(useBlockExplorerBaseUrl())

  return {
    base,
    address: (a: string) => (base && a ? `${base}/address/${a}` : undefined),
    tx: (h?: string) => (base && h ? `${base}/tx/${h}` : undefined),
    token: (t?: string) => (base && t ? `${base}/token/${t}` : undefined),
  }
}
